import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import MobileBottomNav from './MobileBottomNav';
import PwaInstallPrompt from './PwaInstallPrompt';
import { useSidebar } from '../../context/SidebarContext';
import ScannerFeedbackOverlay from '../Scanner/ScannerFeedbackOverlay';
import { processScannedCode } from '../Scanner/scannerSession';
import { useKeyboardWedgeScanner } from '../Scanner/useKeyboardWedgeScanner';
import { unlockScannerAudio } from '../Scanner/scannerAudio';

const isMobile = () => typeof window !== 'undefined' && window.innerWidth <= 768;

const MainLayout = () => {
    const [mobile, setMobile] = React.useState(isMobile());
    const location = useLocation();
    const { isOpen } = useSidebar();
    const isGpt = location.pathname.startsWith('/bananas-gpt');

    useKeyboardWedgeScanner(processScannedCode);

    React.useEffect(() => {
        const handleResize = () => setMobile(isMobile());
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // desktop: полный сайдбар или рейл; mobile: без отступа
    const contentMargin = mobile ? 'ml-0' : isOpen ? 'ml-64' : 'ml-14';

    return (
        <div
            className={`flex h-screen ${isGpt ? 'bg-transparent' : 'bg-gray-100'}`}
            onPointerDown={unlockScannerAudio}
        >
            {!mobile && <Sidebar />}
            <div
                className={
                    'flex-1 transition-[margin] duration-300 ease-in-out ' +
                    contentMargin +
                    (isGpt ? ' overflow-hidden' : ' overflow-auto') +
                    (mobile ? ' pb-24' : '')
                }
            >
                <main className={isGpt ? 'h-full p-0' : mobile ? 'p-0' : 'p-6'}>
                    <Outlet />
                </main>
            </div>
            {mobile && <MobileBottomNav />}
            <ScannerFeedbackOverlay />
            <PwaInstallPrompt />
        </div>
    );
};

export default MainLayout;
